import React from 'react';

type Position = 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right';

interface CornerRibbonProps {
  msg?: string;
  backgroundColor?: string;
  fontColor?: string;
  position?: Position;
  className?: string;
}

const getRotation = (position: Position): number => {
  switch (position) {
    case 'top-left':
      return 0;
    case 'top-right':
      return -270;
    case 'bottom-left':
      return -90;
    case 'bottom-right':
      return 180;
  }
};

const getTextRotation = (position: Position): number => {
  switch (position) {
    case 'top-left':
    case 'top-right':
      return -45;
    case 'bottom-left':
    case 'bottom-right':
      return 135;
  }
};

const getPositionStyle = (position: Position): React.CSSProperties => {
  switch (position) {
    case 'top-left':
      return { top: -10, left: -10 };
    case 'top-right':
      return { top: -10, right: -10 };
    case 'bottom-left':
      return { bottom: -10, left: -10 };
    case 'bottom-right':
      return { bottom: -10, right: -10 };
  }
};

const CornerRibbon: React.FC<CornerRibbonProps> = ({
  msg,
  backgroundColor = '#f6c760',
  fontColor = '#1e2969',
  position = 'bottom-right',
  className,
}) => {
  const rotation = getRotation(position);
  const textRotation = getTextRotation(position);
  const baseTransform = `translate(63.5, 63.42) rotate(${rotation}) translate(-63.5, -63.42) translate(0, -0.075)`;
  const textTransform = `${baseTransform} translate(42.76, 42.40) rotate(${textRotation}) translate(-42.76, -42.40)`;

  return (
    <div
      className={className}
      style={{
        position: 'absolute',
        ...getPositionStyle(position),
        width: 127,
        height: 127,
        zIndex: 99,
        pointerEvents: 'none',
      }}>
      <svg width='127' height='127' viewBox='0 0 127 127'>
        <g>
          {/* Fold ear - bottom edge */}
          <path
            fill='#7B6330'
            d='M0 121.647C.01 128.255 10 127 10 127v-26s-10 5.829-10 20.647z'
            transform={baseTransform}
          />
          {/* Fold ear - right edge */}
          <path
            fill='#7B6330'
            d='M109 12.4c.01 6.733 10 5.37 10 5.37V-8s-10 5.803-10 20.4z'
            transform={`${baseTransform} translate(114, 5) scale(-1, 1) rotate(-270) translate(-114, -5)`}
          />
          {/* Shadow */}
          <path
            fill='#000'
            opacity='0.1'
            d='M18.438 57.599c23.811-23.447 33.526-33.119 40.078-39.2C64.575 11.927 70.983 10.07 71.172 10H111L10 111V70.899c.07-.188 2.53-7.161 8.438-13.3z'
            transform={baseTransform}
          />
          {/* Ribbon body */}
          <path
            fill={backgroundColor}
            d='M7.578 50.012C33.24 24.63 43.71 14.16 50.77 7.578 57.3.57 64.207.076 64.41 0H122s-11.194.505-21.975 10.609l-89.416 90.174C.234 111.078 0 122 0 122V64.41c.076-.203 1.212-7.752 7.578-14.398z'
            transform={baseTransform}
          />
          {/* Text */}
          <text
            fill={fontColor}
            fontFamily='Open Sans, sans-serif'
            fontSize='12'
            fontWeight='600'
            textAnchor='middle'
            dominantBaseline='central'
            x='42.76'
            y='42.40'
            transform={textTransform}>
            {msg}
          </text>
        </g>
      </svg>
    </div>
  );
};

export default CornerRibbon;
